import {
  ACCOUNT_ID_IDENTIFIER,
  CUSTOM_DIVISION_CODE_MAPPING,
  DIRECT_DIVISION_CODE_MAPPING,
  OPTIONAL_SECOND_ACCOUNT_ID,
  SECOND_ACCOUNT_ID,
  STATIC_ACCOUNT_ID,
} from '../../../../../store/constants/accountIdConfigTypes';
import {
  defaultValueForCustomAccountIdMapping,
  defaultValueForDirectDivisionCode,
} from './customAccountIdMappingHelper';
import { requiredCountryMapping, defaultCountryMapping } from './formValidator';

export class DynamicTableUpdateStateHelper {
  constructor({ form, setForm }) {
    this.form = form;
    this.setForm = setForm;
    this.formatWarehouseMappingIfNeeded();
  }

  updateSelectedAccountIdType(accountIdTypeValue, warehouseId) {
    if (!this.form.mapping[warehouseId]) {
      this.form.mapping[warehouseId] = {
        type: accountIdTypeValue,
      };
    } else {
      this.form.mapping[warehouseId].type = accountIdTypeValue;
    }

    if (accountIdTypeValue === CUSTOM_DIVISION_CODE_MAPPING) {
      this.form.mapping[warehouseId].value = defaultValueForCustomAccountIdMapping;
    }

    if (accountIdTypeValue === DIRECT_DIVISION_CODE_MAPPING) {
      this.form.mapping[warehouseId].value = defaultValueForDirectDivisionCode;
    }

    this.setForm({ ...this.form });
  }

  updateStaticAccountId(accountId, warehouseId, options = {}) {
    this.form.mapping[warehouseId] = {
      type: options.type || STATIC_ACCOUNT_ID,
      id: accountId,
    };

    this.setForm({ ...this.form });
  }

  updateSecondaryAccountIds({
    accountIdToUpdate,
    warehouseId,
    indexOfAccountIdToUpdate,
    selectedType = '',
    secondAccountIdConfig = {},
  }) {
    const { isOptional = false } = secondAccountIdConfig;
    const currentAccountId = this.form.mapping[warehouseId]?.id;

    if (Array.isArray(currentAccountId)) {
      currentAccountId[indexOfAccountIdToUpdate] = accountIdToUpdate;
      this.updateStaticAccountId(currentAccountId, warehouseId, {
        type: selectedType || (isOptional ? OPTIONAL_SECOND_ACCOUNT_ID : SECOND_ACCOUNT_ID),
      });
    } else {
      const accountIdArray = ['', ''];
      accountIdArray[indexOfAccountIdToUpdate] = accountIdToUpdate;
      this.updateStaticAccountId(accountIdArray, warehouseId, {
        type: selectedType || (isOptional ? OPTIONAL_SECOND_ACCOUNT_ID : SECOND_ACCOUNT_ID),
      });
    }
  }

  getValueOfSecondaryAccountId(warehouseId, index = 0) {
    if (!Array.isArray(this.form.mapping?.[warehouseId]?.id)) return '';
    return this.form.mapping[warehouseId].id[index];
  }

  getValueOfStaticAccountId(warehouseId) {
    const id = this.form.mapping?.[warehouseId]?.id;

    if (Array.isArray(id)) return id[0];
    return id || '';
  }

  getValueOfSelectedType(form, option) {
    if (option.accountIdTypes?.length === 1) {
      return option.accountIdTypes[0].value;
    }

    return form.mapping[option.id]?.type || option.accountIdTypes[0].value;
  }

  getLabelOfSelectedType(form, option) {
    if (option.accountIdTypes?.length === 1) {
      return option.accountIdTypes[0].label;
    }
    return form.mapping[option.id]?.type || option.accountIdTypes[0].label;
  }

  // private
  formatWarehouseMappingIfNeeded() {
    this.form.mapping = formatWarehouseMappingIfNeeded(this.form.mapping);
  }
}

export function handleDynamicDropdownIdentifierChange(form, identifier) {
  if (identifier === ACCOUNT_ID_IDENTIFIER.SHIP_TO_COUNTRY) {
    return {
      ...form,
      identifier,
      mapping: {
        ...requiredCountryMapping,
        ...defaultCountryMapping,
      },
    };
  }
  return {
    ...form,
    identifier,
    mapping: {},
  };
}

export function formatWarehouseMappingIfNeeded(mapping = {}) {
  try {
    const formValues = Object.values(mapping);
    const isEveryValueAnArray = formValues.every(Array.isArray);
    const shouldCompactValues = formValues.every((val) => val[0].hasOwnProperty('id') && val[0].hasOwnProperty('type'));
    if (isEveryValueAnArray && shouldCompactValues) {
      const updatedMapping = {};
      Object.entries(mapping).forEach(([warehouseId, value]) => {
        updatedMapping[warehouseId] = value[0];
      });
      return updatedMapping;
    }
    return mapping;
  } catch (error) {
    return mapping;
  }
}
